import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";

type SidePanelPositionOptions = {
  /** Mobile web uses the same mid-screen anchor as native (not desktop 10%). */
  preferMobilePosition?: boolean;
};

/** Fixed side action buttons (help, admin feedback) — native + mobile web: ~42% viewport height. */
export function getNativeSidePanelButtonClass(
  extra = "",
  options?: SidePanelPositionOptions,
): string {
  const useMidPosition =
    isNativeCapacitorApp() || options?.preferMobilePosition === true;
  const base = useMidPosition
    ? "fixed right-0 z-40 top-[42%] -translate-y-1/2"
    : "fixed right-0 z-40 top-[10%] -translate-y-1/2";
  return extra ? `${base} ${extra}` : base;
}
